import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  EncashRequest, Fdr, FdrInterestLine, FdrInterestRun, FdrRequest, LienRequest, RenewRequest,
} from '../interfaces/treasury.interface';

const E = ENDPOINTS.FDR;

export const FdrService = {
  list: async (institutionId: string, status?: string): Promise<Fdr[]> =>
    (await axios.get(E.LIST(institutionId), { params: status ? { status } : {} })).data,
  get: async (id: string): Promise<Fdr> => (await axios.get(E.ONE(id))).data,
  create: async (body: FdrRequest): Promise<Fdr> => (await axios.post(E.BASE, body)).data,
  setLien: async (id: string, body: LienRequest): Promise<Fdr> => (await axios.put(E.LIEN(id), body)).data,
  releaseLien: async (id: string, note: string): Promise<Fdr> => (await axios.post(E.LIEN_RELEASE(id), { note })).data,
  encash: async (id: string, body: EncashRequest): Promise<Fdr> => (await axios.post(E.ENCASH(id), body)).data,
  renew: async (id: string, body: RenewRequest): Promise<Fdr> => (await axios.post(E.RENEW(id), body)).data,
  runInterest: async (institutionId: string, period: string): Promise<FdrInterestRun> =>
    (await axios.post(E.INTEREST_RUN, { institutionId, period })).data,
  listRuns: async (institutionId: string): Promise<FdrInterestRun[]> => (await axios.get(E.INTEREST_RUNS(institutionId))).data,
  getRun: async (runId: string): Promise<FdrInterestRun> => (await axios.get(E.INTEREST_RUN_GET(runId))).data,
  interestRegister: async (institutionId: string, from: string, to: string): Promise<FdrInterestLine[]> =>
    (await axios.get(E.INTEREST_REGISTER(institutionId), { params: { from, to } })).data,
  voidInterestLine: async (lineId: string): Promise<FdrInterestLine> => (await axios.post(E.INTEREST_LINE_VOID(lineId))).data,
};
